// Long enough to look at a few products, short enough that a stored list does
// not show old prices or stock.
const MAX_AGE_MS = 15 * 60 * 1000;

export default {
    storedListing: (state) => (key) => state.listings[key] || null,

    listing: (state, getters) => (key) => {
        const listing = getters.storedListing(key);

        return listing && Date.now() - listing.savedAt < MAX_AGE_MS ? listing : null;
    },
};
